import { SAGA_ACTIONS } from '../../../_config'
import { ErrorResponse, SuccessResponse } from '../apiTypes'
import { useApiCall } from '../appApiCallHook'

export interface LargeUploadInitPayload {
    experiment_literal: string
    upload_type: string
    file_name: string
    total_chunks: number
    file_size_bytes: number
    csv_column_names?: string[]
}

export interface LargeUploadChunkPayload {
    formData: FormData
    progress?: (progressEvent: any) => void
}

export function useLargeUploadApi() {
    const callApi = useApiCall()

    const initLargeUpload = <R>(data: LargeUploadInitPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.LARGE_UPLOAD.INIT, data, onSuccess, onError)
    }

    const uploadChunk = <R>(data: LargeUploadChunkPayload, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.LARGE_UPLOAD.UPLOAD_CHUNK, data, onSuccess, onError)
    }

    const completeLargeUpload = <R>(data: { upload_id: string }, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.LARGE_UPLOAD.COMPLETE, data, onSuccess, onError)
    }

    const getLargeUploadStatus = <R>(data: { upload_id: string }, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.LARGE_UPLOAD.GET_STATUS, data, onSuccess, onError)
    }

    const processLargeUpload = <R>(data: { upload_id: string }, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.LARGE_UPLOAD.PROCESS, data, onSuccess, onError)
    }

    const rejectLargeUpload = <R>(data: { upload_id: string; reason?: string }, onSuccess: (resp: SuccessResponse<R>) => void, onError: (resp: ErrorResponse<R>) => void) => {
        callApi(SAGA_ACTIONS.LARGE_UPLOAD.REJECT, data, onSuccess, onError)
    }

    return {
        initLargeUpload,
        uploadChunk,
        completeLargeUpload,
        getLargeUploadStatus,
        processLargeUpload,
        rejectLargeUpload,
    }
}
